const ROUTE_QUOTE_CODES = new Set([
  "CORRIDOR_ROUTING_UNAVAILABLE",
  "SKU_NOT_QUOTABLE",
  "CORRIDOR_NOT_SUPPORTED",
  "ROUTE_NOT_AVAILABLE",
]);

export type QuoteErrorKind = "route" | "retryable";

export function quoteErrorCode(err: unknown): string | undefined {
  const code = (
    err as { response?: { data?: { error?: { code?: string } } } }
  )?.response?.data?.error?.code;
  return typeof code === "string" && code.length > 0 ? code : undefined;
}

/** Route codes mean this funding selection cannot be quoted. Another method may still work. */
export function classifyQuoteError(err: unknown): QuoteErrorKind {
  const code = quoteErrorCode(err);
  return code && ROUTE_QUOTE_CODES.has(code) ? "route" : "retryable";
}
